import { GETTERS_KEYS } from '../../store.const';
import { RECOMMENDATIONS_ACTIONS_KEYS, RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsAction, RecommendationsContext } from '../recommendations.interfaces';
import { getInitialRecommendationsState } from '../recommendations.state';

export class ClearRecommendationsAction implements RecommendationsAction {

  actions = {
    [RECOMMENDATIONS_ACTIONS_KEYS.clearRecommendations]: ({ commit, rootGetters, state }: RecommendationsContext) => {
      const defaultState = getInitialRecommendationsState(rootGetters[GETTERS_KEYS.config.config]);
      commit(RECOMMENDATIONS_MUTATIONS_KEYS.replaceState, Object.assign(defaultState, { origin: state.origin }));
    }
  };
}
